import { render, staticRenderFns } from "./MemberProduct.vue?vue&type=template&id=0ad97c61&"
import script from "./MemberProduct.vue?vue&type=script&lang=js&"
export * from "./MemberProduct.vue?vue&type=script&lang=js&"
import style0 from "./MemberProduct.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports